/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface CreditBalanceResponse {
  org_id: string;
  balance: number;
  credits_per_seat: number;
  seat_count: number;
  total_allocation: number;
  next_cycle_allocation: number;
  period_start: string | null;
  period_end: string | null;
}
